import Text from "components/typography/Text";
import Block from "components/layout/Block";
import DatePresenter from "components/other/DatePresenter";
import UserMediaSkeletor from "components/user/UserMediaSkeletor";
import { StyledTextWrapper } from "components/media/styles";
import formatMessage from "utils/formatMessage";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";

const Message = ({ deletedUser, user, date, type, birthday }) => {
	const { t } = useTranslation(["activity"]);

	const renderMessage = useCallback(() => {
		if (type === 51 && birthday) {
			return formatMessage(t("activity:type.51"), {
				number: birthday,
			});
		} else if (type === 51) {
			return t("activity:type.empty51");
		} else {
			return t(`activity:type.${type}`);
		}
	}, [type, birthday]);

	return (
		<StyledTextWrapper removePaddingOnMobile>
			{!deletedUser ? (
				<UserMediaSkeletor
					alignCenter
					user={user}
					size="small"
					content={
						<Text small color="grey">
							<DatePresenter date={date} />
						</Text>
					}
					vipProps={{ height: 14, marginBottom: 0.1 }}
				/>
			) : (
				<Text small color="grey">
					<DatePresenter date={date} />
				</Text>
			)}

			<Block mt={3}>
				{deletedUser && <Text bold>{deletedUser + " "}</Text>}
				<Text>{renderMessage()}</Text>
			</Block>
		</StyledTextWrapper>
	);
};

export default Message;
